import React from "react";
import { Box, List, Typography } from "@mui/material";
import SidebarItem from "./SidebarItem";
import { MENU_GROUPS } from "../../constants/menu";
import LogoutIcon from "@mui/icons-material/Logout";

import { SidebarProps } from "../../types/interface";
import { APP_STRINGS, MENU_STRINGS } from "../../constants/strings";

import "./sidebar.css";
import { logout } from "../../utils/auth";

const Sidebar: React.FC<SidebarProps> = ({ collapsed }) => {

  // ✅ FIX: define handler
  const handleLogout = () => {
    logout();
  };

  return (
    <Box className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      {/* TOP */}
      <Box className="sidebar-inner">
        {!collapsed && (
          <>
            <Typography className="sidebar-logo">
              {APP_STRINGS.APP_NAME}
            </Typography>
            <Box className="sidebar-divider" />
          </>
        )}

        {/* MENU */}
        <List className="sidebar-menu">
          {MENU_GROUPS.map((group, index) => (
            <Box key={index}>
              {!collapsed && group.title && (
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "var(--text-secondary)",
                    px: 1,
                    mb: 1,
                    mt: index !== 0 ? 2 : 0,
                  }}
                >
                  {group.title}
                </Typography>
              )}

              {group.items.map((item) => (
                <SidebarItem
                  key={item.path}
                  {...item}
                  collapsed={collapsed}
                />
              ))}

              {index !== MENU_GROUPS.length - 1 && (
                <Box className="sidebar-divider" />
              )}
            </Box>
          ))}
        </List>
      </Box>

      {/* BOTTOM */}
      <Box className="sidebar-bottom">
        <Box className="sidebar-divider" />

        <SidebarItem
          label={MENU_STRINGS.LOGOUT}
          path="#"
          icon={LogoutIcon}
          collapsed={collapsed}
          onClick={handleLogout} // ✅ FIXED
        />
      </Box>
    </Box>
  );
};

export default Sidebar;